import { preciseCurrencyFormatter } from '@shared/helpers/format-currency';
import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { casesOf } from '../../../../data/order-item';
import { caseDiscount } from '../../../../data/product';
import type { ProductOrderItem } from '../data/product-order-item';

export const swingSavingsColumn: StrictColumnDef<ProductOrderItem> = defineColumn<ProductOrderItem>(
  {
    id: 'Buyup Savings',
    minWidth: 80,
    accessorFn: (orderItem) => {
      const swingSavings = caseDiscount(orderItem.product);

      if (swingSavings === 0) {
        return preciseCurrencyFormatter(0);
      }

      return preciseCurrencyFormatter(swingSavings * casesOf(orderItem));
    },
  }
);
